<template>
  <BHLink
    :colorless="true"
    :href="href"
    :target="target"
    class="comments-crumb"
    @click="$emit('click-comments-icon', href)"
  >
    <SvgAsset
      :content="commentsPath"
      class="comments-crumb__icon"
    />
    <span
      v-if="!hideCommentsCount"
      class="comments-crumb__count"
      >{{ commentsCount || '' }}
    </span>
  </BHLink>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BHLink from '@/components/BHLink.vue';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import commentsPath from '@/assets/images/svg/comments.svg?raw';

  export default defineNuxtComponent({
    name: 'CommentsCrumb',

    components: {
      BHLink,
      SvgAsset,
    },

    props: {
      target: {
        type: String as PropType<string | null>,
        default: '_self',
      },

      href: {
        required: true,
        type: String as PropType<string>,
      },

      hideCommentsCount: {
        type: Boolean as PropType<boolean>,
        default: false,
      },

      commentsCount: {
        type: Number as PropType<number>,
        default: 0,
      },
    },

    emits: ['click-comments-icon'],

    computed: {
      commentsPath: () => commentsPath,
    },
  });
</script>

<style lang="scss" scoped>
  .comments-crumb {
    display: flex;
    align-items: center;
    color: $text-color--1;
    @include font(
      (
        'fw': 500,
        'lh': 20px,
        'fs': 14px,
      )
    );

    &__icon {
      z-index: 1;
      :deep() {
        svg path {
          fill: $icon-color--1;
        }
      }
      min-width: 16px;
      max-width: 16px;
      min-height: 16px;
      max-height: 16px;
    }

    &-count {
      margin-left: 2px;
    }

    @include hover {
      color: $mainBlack;
      .comments-crumb__icon {
        :deep() {
          svg path {
            fill: $mainBlack;
          }
        }
      }
    }
  }
</style>
